export default __webpack_public_path__ + "static/media/ios-warning.57f7dffb.svg";